import styled from 'styled-components/macro';
import { withTheme } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';


export const Link = withTheme(styled(RouterLink)`
    text-decoration: none;
    color: ${props => props.theme.palette.primary.dark};
`);